export enum HtmlFieldType {
  TEXT = 'string',
  FILE = 'file'
}
